import { needLabel } from './playVitals.js';

const read = (being, keys, fallback) => {
  for (const key of keys) {
    const value = being?.[key];
    if (value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value))) return Number(value);
  }
  return fallback;
};

export default function CharacterVitals({ being }) {
  const resources = [
    ['health', 'Health', ['currentHp', 'health', 'currentHealth', 'hitPoints', 'currentHitPoints'], ['maxHp', 'maxHealth', 'maximumHealth', 'maxHitPoints', 'hitPointsMax'], 100],
    ['stamina', 'Stamina', ['currentStamina', 'current_stamina'], ['maxStamina', 'max_stamina'], 100],
    ['mana', 'Mana', ['currentPp', 'magic', 'currentMagic', 'mana', 'currentMana'], ['maxPp', 'maxMagic', 'maximumMagic', 'maxMana', 'manaMax'], 0],
  ].map(([key, label, currentKeys, maxKeys, fallback]) => {
    const max = Math.max(0, read(being, maxKeys, fallback));
    const value = Math.max(0, Math.min(max, read(being, currentKeys, max)));
    return { key, label, value, max, detail: `${Math.floor(value)}/${Math.floor(max)}` };
  });
  const needs = ['hunger', 'thirst', 'intoxication'].map(key => {
    const value = Math.max(0, Math.min(100, read(being, [key], 0)));
    return { key, label: key === 'hunger' ? 'Hunger' : key === 'thirst' ? 'Thirst' : 'Intoxication', value, max: 100,
      detail: key === 'intoxication' ? `${Math.floor(value)}%` : `${needLabel(key, value)} (${Math.floor(value)}%)`,
      explanation: key === 'intoxication' ? 'Higher is worse. Impairment increases at 20%, 40%, 65% and 85%.'
        : 'Higher is worse. Supply warnings occur at 50%, 75% and 100%. At 100%, deprivation drains stamina, limits stamina recovery, and eventually damages health.' };
  });
  return <section className="character-vitals" aria-label="Character vitals">
    {[...resources, ...needs].map(({ key, label, value, max, detail, explanation }) => (
      <div key={key} className={`character-vital character-vital-${key}`} title={explanation}>
        <div className="character-vital-label"><strong>{label}</strong><span>{detail}</span></div>
        <div className="character-vital-track" role="meter" aria-label={`${label}: ${detail}`}
          aria-valuemin={0} aria-valuemax={Math.max(1, max)} aria-valuenow={value} aria-valuetext={detail}>
          <span style={{ width: `${max ? value / max * 100 : 0}%` }} />
        </div>
      </div>
    ))}
  </section>;
}
